import { Formik } from 'formik';
import { Button, Form, Grid, Modal } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useState } from 'react';
//import { useNavigate } from 'react-router-dom';

function ResetPasswordOnFirstEverLogin() {
  const { userStore } = useStore();
  const [open, setOpen] = useState(true);
  const {
    userStore: { logout },
    commonStore,
  } = useStore();
  return (
    <Formik
      initialValues={{
        email: '',
        id: userStore?.user?.id,
        password: '',
        error: null,
        newPassword: '',
        image: '',
        fullName: '',
        customerName: ' ',
        departmentName: '',
        addressLine1: '',
        addressLine2: '',
        country: '',
        state: '',
        city: '',
        postalCode: '',
        alternatePhoneNumber: '',
        remarks: '',
        role: '',
        workPosition: '',
        superior: '',
        website: '',
        workDepartment: '',
        workApplicationsKnown: '',
        languagesKnown: '',
        roleId: '',
        isAdmin: false,
        isDeleted: false,
      }}
      onSubmit={(values) => {
        userStore.resetPasswordOnFirstEverLogin(values);
        //localStorage.clear();
      }}
      validationSchema={Yup.object({
        // email: Yup.string().required().email(),
        password: Yup.string().required('Please Enter your Old password'),
        newPassword: Yup.string()
          .required('Please Enter your New password')
          /* eslint-disable */
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            'Must Contain 8 to 18 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
          )
          .notOneOf(
            [Yup.ref('password')],
            'New Password must be different than current password',
          ),
        checkPassword: Yup.string()
          .required('Please Enter your New password')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            'Must Contain 8 to 18 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
          )
          .oneOf([Yup.ref('newPassword')], 'Passwords does not match'), //.oneOf([Yup.ref("newPassword")],'New Password must be different than current password'),
      })}
    >
      {({ handleSubmit, isSubmitting, isValid, dirty }) => (
        <>
          <Modal onOpen={() => setOpen(true)} open={open}>
            <h1
              style={{ color: 'black', padding: '16px' }}
              //Change Password
            >
              {
                (userLanguage[0].EditProfileChangePassword?.EPCPMHL01 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
            </h1>
            <Form
              className="ui form error"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <Grid container columns={3}>
                <Grid.Column computer={16} tablet={16}>
                  <MyTextInput
                    type="password"
                    name="password"
                    label={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPML01 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Current Password'
                    placeholder={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPMTB01 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Current Password'
                  />
                </Grid.Column>
                <Grid.Column computer={16} tablet={16}>
                  <MyTextInput
                    type="password"
                    name="newPassword"
                    label={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPML02 as any
                      )?.[`${commonStore.language.key}`]
                    } //'New Password'
                    placeholder={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPMTB02 as any
                      )?.[`${commonStore.language.key}`]
                    } //'New Password'
                  />
                </Grid.Column>
                <Grid.Column computer={16} tablet={16}>
                  <MyTextInput
                    type="password"
                    name="checkPassword"
                    label={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPML03 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Confirm New Password'
                    placeholder={
                      (
                        userLanguage[0].EditProfileChangePassword
                          ?.EPCPMTB03 as any
                      )?.[`${commonStore.language.key}`]
                    } //'Confirm New Password'
                  />
                </Grid.Column>
              </Grid>
              <Button.Group floated="right" style={{ margin: '20px' }}>
                <Button
                  primary
                  //onClick={() => modalStore.closeModal()}
                  //Cancel
                  onClick={(e: any) => {
                    e?.preventDefault();
                    logout();
                  }}
                >
                  {
                    (userLanguage[0].User?.UDDB2 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Button>
                {/* <Button.Or text={(userLanguage[0].EditProfileChangePassword?.EPCPMB02 as any)?.[`${commonStore.language.key}`]}/> */}
                <Button
                  color="red"
                  disabled={!isValid || !dirty || isSubmitting}
                  loading={isSubmitting}
                  type="submit"
                  content="Change Password"
                  //Change Password
                >
                  {
                    (
                      userLanguage[0].EditProfileChangePassword?.EPCPMB03 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </Button>
              </Button.Group>
            </Form>
          </Modal>
        </>
      )}
    </Formik>
  );
}

export default ResetPasswordOnFirstEverLogin;
